module.exports = __webpack_public_path__ + "static/media/icon-left.b85a9ad7.svg";